<template>
	<div id="app" :key="$route.fullPath" :style="{overflowY: islogin ? 'auto' : 'hidden'}">
		<router-view />
	</div>
</template>

<script>
export default {
	name: 'App',
	components: {
	},
	data() {
		return {
			islogin: false
		}
	},
	mounted() {
		const path = this.$route.path
		if (path == '/login') {
			this.islogin = true
		} else {
			this.islogin = false
		}
		// document.addEventListener('keydown', this.disableDevTools)
	},
	methods: {
		disableDevTools(event) {
			// 禁止 F12
			if (event.key === "F12") {
				event.preventDefault();
			}
			// 禁止 Ctrl + Shift + I 打开开发者工具
			if (event.ctrlKey && event.shiftKey && event.key === 'I') {
				event.preventDefault();
			}
			// 禁止 Ctrl + Shift + C 打开检查元素
			if (event.ctrlKey && event.shiftKey && event.key === 'C') {
				event.preventDefault();
			}
		}
	},
	beforeDestroy() {
		document.removeEventListener('keydown', this.disableDevTools);
	},
};
</script>
<style lang="scss">
body {
	overflow-x: hidden;
}
#app {
	-webkit-font-smoothing: "antialiased";
	-moz-osx-font-smoothing: "grayscale";
	/* text-align: center; */
	// color: #fff;
	height: 100vh;
	width: 100%;
	background: #131313;
	overflow: hidden;
}
@font-face {
	font-family: "Hei";
	src: url("./assets/fonts/SourceHanSansCN-Medium.woff2");
}
@font-face {
	font-family: "pmzd";
	src: url("./assets/fonts/PangMenZhengDao.woff2");
}
::-webkit-scrollbar {
	width: 8px;
	height: 16px;
	background-color: transparent;
}
/*定义滚动条轨道内阴影+圆角*/
::-webkit-scrollbar-track {
	-webkit-box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.3);
	border-radius: 10px;
	background-color: rgba(2, 28, 51, 0.7);
}
/*定义滑块内阴影+圆角*/

::-webkit-scrollbar-thumb {
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.3);
	background-image: linear-gradient(#0089FF, #0089FF);
}
.head_animation {
	opacity: 0;
	animation: 1s headanimation linear 1;
	animation-fill-mode: forwards;
}
@keyframes headanimation {
	from {
		opacity: 0;
		transform: translateY(-100%);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}
.left_animation_1 {
	opacity: 0;
	animation: 1s 1s leftanimation linear 1;
	animation-fill-mode: forwards;
}
.left_animation_2 {
	opacity: 0;
	animation: 1s 1.7s leftanimation linear 1;
	animation-fill-mode: forwards;
}
.left_animation_3 {
	opacity: 0;
	animation: 1s 2.4s leftanimation linear 1;
	animation-fill-mode: forwards;
}
@keyframes leftanimation {
	from {
		opacity: 0;
		transform: translateX(-100px);
	}
	to {
		opacity: 1;
		transform: translateX(0);
	}
}
.right_animation_1 {
	opacity: 0;
	animation: 1s 1s rightanimation linear 1;
	animation-fill-mode: forwards;
}
.right_animation_2 {
	opacity: 0;
	animation: 1s 1.7s rightanimation linear 1;
	animation-fill-mode: forwards;
}
.right_animation_3 {
	opacity: 0;
	animation: 1s 2.4s rightanimation linear 1;
	animation-fill-mode: forwards;
}
@keyframes rightanimation {
	from {
		opacity: 0;
		transform: translateX(100px);
	}
	to {
		opacity: 1;
		transform: translateX(0);
	}
}
.bottom_animation {
	opacity: 0;
	animation: 1s bottomanimation linear 1;
	animation-fill-mode: forwards;
}
@keyframes bottomanimation {
	from {
		opacity: 0;
		transform: translateY(100%);
	}
	to {
		opacity: 1;
		transform: translateX(0);
	}
}
.center_animation_1 {
	opacity: 0;
	animation: 1s 1s centeranimation linear 1;
	animation-fill-mode: forwards;
}
.center_animation_2 {
	opacity: 0;
	animation: 1s 1s centeranimation linear 1;
	animation-fill-mode: forwards;
}
@keyframes centeranimation {
	from {
		opacity: 0;
		transform: translateY(80px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}
@keyframes centeranimation2 {
	from {
		opacity: 0;
		transform: translateY(-80px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}
.tdt-control > div > img {
     display: none;
}
.luckysheet-share-logo {
	display: none;
}
.luckysheet_info_detail_back {
	display: none;
}
.componentListAll .el-loading-mask {
  background-color: transparent;
}
.source_input {
	.el-input__inner {
		background: #2E2F34;
		border: 1px solid #4C4D50;
		color: #7E7E7E;
	}
}
.mark {
	background-size: 100% 100%;
	position: absolute;
	width: 1920px;
	height: 1080px;
	z-index: 401;
	pointer-events: none;
}
.tops{
	width:100%;
	display:block;
}	
.content {
	display: flex;
	height: calc(100% - 10px);
	margin-top: 10px;
	z-index: 1;
	position: relative;
	z-index: 402;
	.left {
		margin-left: 34px;
		width: 444px;
	}
	.center {
		width: 924px;
		position: relative;
		margin:0 20px;
	}
	.right {
		margin-right: 34px;
		width: 444px;
	}
}
.sb-select {
	height: 24px;
	width: 80px;
	z-index: 1;
	pointer-events: auto;
	&.month-select {
		background: url(@/assets/template_1/select-bg.png) top right no-repeat;
		background-size: 100% 100%;
	}
	&.day-select {
		margin-left: 8px;
		background:red;
		background: url(@/assets/template_1/select-bg1.png) no-repeat;
		background-size: 100% 100%;
		padding-right:0px;
	}
	.el-input--suffix {
		height: 24px;
	}
	.el-input__inner {
		font-size: 12px;
		border: 0;
		background: transparent;
		width: 80px;
		height: 24px;
		line-height: 24px;
		padding-right: 45px !important;
		color: #fff;
	}
	.el-input__icon {
		line-height: 24px;
		font-size: 10px;
	}
	.el-input__suffix {
	}
}
.componentContents{
	width:92%;
	margin:20px auto;
	overflow:hidden;
}
.componentContents .single{
	overflow:hidden;
	font-size:14px;
	width:100%;
	display:flex;
	margin-bottom:20px;
}	
.componentContents .s_single{
	width:48%;
	padding-left:2%;
	display:flex;
}	
.componentContents .s_single .l_txt2{
	width:28%;
	padding-right:2%;
	text-align:right;
	line-height:40px;
}			
.componentContents .single_btn{
	overflow:hidden;
	font-size:14px;
	width:100%;
	margin-bottom:20px;
	text-align:center;
}	
.componentS.title .single_btn{
	text-align:left;
}	
.componentContents .single_tip{
	overflow:hidden;
	font-size:14px;
	line-height:40px;
	width:100%;
	margin-bottom:20px;
	display:flex;
}	
.componentContents .single_tip .l_txt{
	width:15%;
	padding-right:2%;
	text-align:right;
	line-height:40px;
}		
.componentContents .single .l_txt{
	width:15%;
	padding-right:2%;
	text-align:right;
	line-height:40px;
}
.single_row{display:block;width:100%;z-index:2}

/*	更多样式 */
.flex-cc2 {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
}
.more-dialog {
	margin: 0 !important;
	height: 100%;
	background: transparent !important;
	backdrop-filter: blur(20px);
	display: flex;
	align-items: center;
	justify-content: center;
}
.more-title {
	font-family: PangMenZhengDao;
	font-weight: 600;
	font-size: 54px;
	color: #FFFFFF;
	text-align: center;
	background: linear-gradient(0deg, #179CFE 0%, #FFFFFF 100%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
}
.more-rectangle {
	width: 880px;
	height: 543px;
	text-align: center;
	background: url(@/assets/log-rectangle.png) no-repeat;
	background-size: 100% 100%;
}
.more-name {
	font-family: Source Han Sans CN;
	font-weight: 400;
	font-size: 39px;
	color: #FFFFFF;
	padding-top: 68px;
}
.lock-img {
	width: 22px;
	height: 25px;
	margin-left: 36px;
}
.more-content .el-input {
	margin-top: 36px;
	background: rgba(24,68,105,0.61);
	border: 1px solid rgba(0,0,0,0.3);
	border-radius: 3px;
	width: 557px !important;
	height: 68px;
	line-height: 68px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	font-size: 21px;
	color: #AAACB9;
	display: block;
}
.more-content .el-input+.el-input {
	margin-top: 18px;
}
.more-content .el-input .el-input__inner {
	padding-left: 100px;
}
.more-button {
	margin: 42px auto 0 !important;
	width: 557px;
	height: 68px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	font-size: 24px !important;
	color: #FFFFFF;
	background: linear-gradient(0deg, #128DFF 0%, #1ABCFF 100%) !important;
	border-radius: 3px !important;
	display: flex;
	align-items: center;
	justify-content: center;
}	

/*	登录样式 */
.flex-cc {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
}
.log-dialog {
	margin: 0 !important;
	height: 100%;
	background: transparent !important;
	backdrop-filter: blur(20px);
	display: flex;
	align-items: center;
	justify-content: center;
}
.log-title {
	font-family: PangMenZhengDao;
	font-weight: 600;
	font-size: 54px;
	color: #FFFFFF;
	text-align: center;
	background: linear-gradient(0deg, #179CFE 0%, #FFFFFF 100%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
}
.log-rectangle {
	width: 880px;
	height: 543px;
	text-align: center;
	background: url(@/assets/log-rectangle.png) no-repeat;
	background-size: 100% 100%;
}
.log-name {
	font-family: Source Han Sans CN;
	font-weight: 400;
	font-size: 39px;
	color: #FFFFFF;
	padding-top: 68px;
}
.lock-img {
	width: 22px;
	height: 25px;
	margin-left: 36px;
}
.log-content .el-input {
	margin-top: 36px;
	background: rgba(24,68,105,0.61);
	border: 1px solid rgba(0,0,0,0.3);
	border-radius: 3px;
	width: 557px !important;
	height: 68px;
	line-height: 68px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	font-size: 21px;
	color: #AAACB9;
	display: block;
}
.log-content .el-input+.el-input {
	margin-top: 18px;
}
.log-content .el-input .el-input__inner {
	padding-left: 100px;
}
.log-button {
	margin: 42px auto 0 !important;
	width: 557px;
	height: 68px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	font-size: 24px !important;
	color: #FFFFFF;
	background: linear-gradient(0deg, #128DFF 0%, #1ABCFF 100%) !important;
	border-radius: 3px !important;
	display: flex;
	align-items: center;
	justify-content: center;
}	
.more_table{width:80%;margin:0 auto;display:block;}
.page_bottom {
	margin-bottom: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	width:calc(100% - 75px);
	>span {
		font-family: Source Han Sans CN;
		font-weight: 400;
		font-size: 14px;
		color: #90D4FF;
		line-height: 14px;
	}
	.el-pagination {
		.btn-prev, .btn-next, .btn-quicknext {
			background-color: #2E2F34 !important;
		}
		.number {
			background-color: #2E2F34 !important;
			&.active {
				background-color: #0089FF !important;
			}
		}
	}
}
.back-mask {
	position: absolute;
	width: 100%;
	height: 100%;
	background-color: #000;
	opacity: .3;
	z-index: 501;
}
.componentS {
	.vxe-toolbar {
		background: transparent !important;
	}
}
// 水印
.water-mark {
	width: 100%;
	height: 100%;
	position: absolute;
	z-index: 9999;
	pointer-events: none;
	left: 0;
	top: 0;
	background: url(@/assets/water-mark.png) no-repeat;
	background-size: 100% 100%;
}
</style>